import { SPATEM } from '_lib/api';
import { Map } from 'leaflet';
import React, { FC, ReactElement } from 'react';

import SpatemMarker from './markers/SpatemMarker';

const Spatems: FC<{ spatems: SPATEM[]; mapRef: Map }> = ({ spatems, mapRef }): ReactElement => (
  <>
    {spatems
      .filter((spatem) => spatem?.location?.coordinates)
      .map((spatem) => (
        <SpatemMarker key={spatem.id} id={spatem.id} mapRef={mapRef} />
      ))}
  </>
);

export default React.memo(Spatems);
